<template>
  <el-row>
    <span style="font-size: 14px;" v-if="title !== ''">
      {{ title + ": " }}
    </span>
    <span
      v-for="color in colorList"
      :key="color.color"
      style="display: inline-block; height: 30px; line-height: 30px;margin-right: 15px; font-size: 14px;"
    >
      <span
        v-if="icon === ''"
        style="display: inline-block; height: 14px; width: 14px; border-radius: 2px;"
        :style="{ 'background-color': color.color }"
      ></span>
      <em
        v-else
        :class="icon"
        style="font-size: 16px;"
        :style="{ color: color.color }"
      ></em>
      {{ color.text }}
    </span>
  </el-row>
</template>
<script>
export default {
  props: {
    colorList: {
      type: Array,
      default() {
        return [];
      }
    },
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
